import { useLocation } from "react-router";

/** Each value is the tab's path segment under `/settings/`. */
export enum SettingsTab {
  Organization = "organization",
  Tokens = "tokens",
  Usage = "usage",
  AI = "ai",
  Secrets = "secrets",
  Ingestion = "ingestion",
  Sessions = "sessions",
  Integrations = "integrations",
  CustomFields = "custom-fields",
  Assets = "assets",
}

const SETTINGS_TABS = new Set<string>(Object.values(SettingsTab));

/**
 * The tab the first segment after `/settings/` names ("ai" in
 * "/settings/ai/register-mcp-server"), or Organization when it names none.
 */
function deriveActiveTabFromUrl(pathname: string): SettingsTab {
  const segment = pathname.replace(/^\/settings\/?/, "").split("/")[0];
  return SETTINGS_TABS.has(segment)
    ? (segment as SettingsTab)
    : SettingsTab.Organization;
}

export function useActiveSettingsTab(): SettingsTab {
  return deriveActiveTabFromUrl(useLocation().pathname);
}
